<template>
	<slot
		:errors="errors"
		:error-message="errorMessage"
	></slot>
</template>

<script setup>
import { computed } from 'vue'
import { useField } from 'vee-validate';
import * as yup from 'yup';

const props = defineProps({
	name: String,
	validatorString: String
});

// Create validator function from string
const validator = computed(() => {
    return new Function('yup', `return ${props.validatorString}`)(yup);
});

const { errors } = useField(() => props.name, validator, {
	type: 'checkbox'
});

const errorMessage = computed(() => {
	return errors.value.length > 0 ? errors.value.map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1)).join('. ') + '.' : '';
});
</script>
